import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["adjustCoupon", "couponType", "userBalance", "userStatus", "couponPrice", 
                    "previewUrl", "couponId", "gameUrl", "gameId", "gameLink"];

  connect(){
    if(document.getElementById("adjust_coupon")){
      if(this.adjustCouponTarget.value === "true"){
        this.coupon_detail();
      }  
    }
  }

  coupon_detail() {
    if(this.gameUrlTarget.value.length > 0) {
      var coupon = {
        id: parseInt(this.couponIdTarget.value),
        game_id: this.gameIdTarget.value,
        game_url: this.gameUrlTarget.value,
        preview_url: this.previewUrlTarget.value,
        price: parseInt(this.couponPriceTarget.value)
      }
    }
    else {
      var coupon = {
        id: parseInt(this.couponIdTarget.value),
        preview_url: this.previewUrlTarget.value,
        price: parseInt(this.couponPriceTarget.value)
      }
    }
    
    const userBalance = parseInt(this.userBalanceTarget.value);
    const couponType = this.couponTypeTarget.value;
    const userStatus = this.userStatusTarget.value;
    const authStatus = true;
    if(userStatus == "false"){
       authStatus = false;
    }

    const payload = JSON.stringify({
      ...coupon,
      balance: userBalance,
      openedFrom: "partner"
    });

    if (window?.Android && (couponType === "coupon" || couponType === "game")) {
      Android.openCouponBottomSheet(payload);
    } else if (window?.Android && couponType === "loyalty") {
      Android.openLoyaltyBottomSheet(payload);
    }

    if (window.webkit && window.webkit.messageHandlers) {
      webkit.messageHandlers.performAction.postMessage({
        action: "showCoupon",
        data: {
          ...coupon,
          balance: userBalance,
          type: couponType,
          openedFrom: "partner",
          is_authorized: authStatus
          // opened from discover - discover
          // opened from partner - partner
        },
      });
    }
  }
}
